import {React, observer, classNames} from '@api'
import {useWhiteboardStore} from '@modules/whiteboard'
import {BackToContent} from './BackToContent'
import {PrimaryTools} from './PrimaryTools'
import {ActionButton} from './ActionButton'
import {DeleteButton} from './DeleteButton'
import * as css from './ToolsPanel.css'

export const ToolsPanel = observer<{className?: string}>(function ToolsPanel({className}): JSX.Element {
  const {settings: {ui: {isDebugMode}}, handleMenuBlur} = useWhiteboardStore()
  return (
    <div className={classNames(css.panelContainer, className)} onBlur={handleMenuBlur}>
      <div className={css.centerWrap}>
        <BackToContent/>
        <div className={css.primaryTools}>
          <ActionButton/>
          <PrimaryTools/>
          <DeleteButton/>
        </div>
      </div>
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/ToolsPanel/ToolsPanel.tsx